/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageDynamicFormsDto } from '../../models/work-package-dynamic-forms-dto';

export interface GetWorkPackageDynamicForms$Params {
  id: string;
}

export function getWorkPackageDynamicForms(http: HttpClient, rootUrl: string, params: GetWorkPackageDynamicForms$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDynamicFormsDto>> {
  const rb = new RequestBuilder(rootUrl, getWorkPackageDynamicForms.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageDynamicFormsDto>;
    })
  );
}

getWorkPackageDynamicForms.PATH = '/v0/workPackages/{id}/dynamic-forms';
